export default {
  allChatData: {}, // 所有聊天记录
  chatMsgList: [], // 与指定用户的聊天记录
  curUserInfo: {}, // 当前聊天人的用户信息
  receivingUser: '',
  receiver: {},
  exhibitorDialogVisible: false,
  chatEmployeeList: [],
  // TODO 暂时隐藏
  // newMessageComing: false,
  // newMailComing: false,
  // 员工管理
  employeeDetail: {},
}
